/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminUser,
  SessionInput,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary create session
 */
export const createSession = (
    sessionInput: MaybeRefOrGetter<SessionInput>,
 signal?: AbortSignal
) => {
      sessionInput = toValue(sessionInput);

      return axiosClient<AdminUser>(
      {url: `/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sessionInput, signal
    },
      );
    }




export const getCreateSessionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext> => {

const mutationKey = ['createSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, CreateSessionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSession(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    export type CreateSessionMutationBody = SessionInput
    export type CreateSessionMutationError = ErrorType<StandardError>
    export type CreateSessionMutationVariables = {data: SessionInput}

    /**
 * @summary create session
 */
export const useCreateSession = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,CreateSessionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        CreateSessionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSessionMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Session
 */
export const destroySession = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/sessions`, method: 'DELETE', signal
    },
      );
    }




export const getDestroySessionMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext> => {

const mutationKey = ['destroySession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroySession>>, void> = () => {


          return  destroySession()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroySessionMutationResult = NonNullable<Awaited<ReturnType<typeof destroySession>>>

    export type DestroySessionMutationError = ErrorType<StandardError>


    /**
 * @summary Destroy Session
 */
export const useDestroySession = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroySession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroySession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroySessionMutationOptions(options), queryClient);
    }
